var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SettingsSection",
    { attrs: { title: _vm.t("activity", "Daily activtiy summary") } },
    [
      _c(
        "CheckboxRadioSwitch",
        {
          attrs: { checked: _vm.activityDigestEnabled },
          on: {
            "update:checked": function ($event) {
              _vm.activityDigestEnabled = $event
            },
          },
        },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(
                _vm.t("activity", "Send daily activity summary in the morning")
              ) +
              "\n\t"
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }